import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Col, Row } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import ModalMessage from '../../shared/components/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import "moment/locale/es";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import MCADAailableTimesList from './MCADAailableTimesList';
import MCADAailableTimesListActions from './MCADAailableTimesListActions';
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";


const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

var user = sessionStorage.getItem('usuario');
user = JSON.parse(user);

class ModalChangeAppointmentDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            isLoading: false,
            availableTimes: [],
            confirmedCitas: [],
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' },
            typeAgendaList: [],
            typeAgenda: null
        };
    };

    componentDidMount = () => {
        this.loadTypeAgendas();
        this.verifyAvailableTimes(this.props.date);
    }

    handlerActualServiceSelected = (value) => {
        this.setState({ actualServiceSelected: value });
    }

    verifyAvailableTimes = async (dateFilter, serviceFilter) => {
        if (dateFilter != null && dateFilter != undefined && serviceFilter != undefined && serviceFilter != null) {
            this.setState({ isLoading: true });
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/buscar-disponibilidad', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ fecha: dateFilter, id_servicio: serviceFilter, tipo_agenda: this.state.typeAgenda })
            }).then(response => {
                return response.json();
            }).then(data => {
                this.setState({ availableTimes: data, isLoading: false });
            }).catch((error) => {
                this.setState({ isLoading: false });
                console.error('Error:', error);
                this.setState({ openAlert: true, modalAlert: { color: 'danger', title: "Error de Filtros", message: "Ha ocurrido un error buscando las Jornadas Disponibles del dia seleccionado" } });
            });
        }
    }

    cleanData = () => {
        this.setState({
            errors: {},
            isLoading: false,
            availableTimes: [],
            confirmedCitas: [],
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' }
        }, () => {
            this.props.refreshOriginalDates();
            this.props.handlerCloseOpenModalChangingAppointment(false);
        });
    }

    handlerConfirmedCitas = async (value) => {
        value.id_servicio = this.props.serviceChangeDate;
        value.detalle_servicio = this.props.activitiesAppointment.find(ser => ser.id_servicio == this.props.serviceChangeDate);
        value.excepcion_cobro = await this.validateControlAppointment(value);
        this.setState({ confirmedCitas: [...this.state.confirmedCitas.filter(confCita => value.id_servicio != confCita.id_servicio), value] });
    }

    validateCalendarConfirmed = (id_servicio) => {
        let confirmed = "";
        let finded = this.state.confirmedCitas.find(con => con.id_servicio == id_servicio);
        if (finded != null && finded != undefined) {
            confirmed = moment(finded.start).format("DD/MM/YYYY h:mm a");
            confirmed = finded.nombre_profesional.toString() + " - " + confirmed.toString() + ": ";
        }
        return confirmed;
    }

    validateExcentPayment = (id_servicio) => {
        let finded = this.state.confirmedCitas.find(con => con.id_servicio == id_servicio);
        if (finded != null && finded != undefined) {
            if (finded.excepcion_cobro == true) {
                return true;
            }
            else {
                return false;
            }
        }
        else
        {
            return false;
        }
    }

    validateCalendarConfirmedSome = (id_servicio) => {
        let finded = this.state.confirmedCitas.some(con => con.id_servicio == id_servicio);
        return finded;
    }

    validateAgendaConfirmedSome = (id_jornada, id_agenda) => {
        let finded = this.state.confirmedCitas.some(con => con.id_jornada == id_jornada && con.id_agenda == id_agenda);
        return finded;
    }

    confirmedNewCitas = async () => {
        let clinica = JSON.parse(sessionStorage.getItem('clinica'));
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/reagendar', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ 
                id_cita: this.props.dataEvent.id_cita, 
                arrJornadas: this.state.confirmedCitas,
                id_usuario: user != null && user != undefined ? user.id_usuario : JSON.parse(sessionStorage.getItem('usuario')).id_usuario,
                isTheServicePaid: !!clinica ? clinica.hasOwnProperty('cobro_consulta_control') ? clinica.cobro_consulta_control : false : false
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el sistema al Reagendar la Cita");
            }
        }).then(data => {
            this.setState({ openAlert: true, modalAlert: { color: 'success', title: 'Cita Reagendada', message: 'La cita se ha reagendado correctamente a los dias especificados' } });
            console.log(data);
        }).catch((error) => {
            this.setState({
                openAlert: true,
                modalAlert: { color: 'danger', title: 'Error al Reagendar la Cita, es posible que la Jornada ya este ocupada por otro paciente', message: 'Ha ocurrido un error en el sistema al Reagendar la Cita' }
            }, () => {
                this.verifyAvailableTimes(this.props.date, this.props.serviceChangeDate);
            });
            //console.error('Error:', error);
        });
    }

    loadTypeAgendas = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}atencion/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error');
            }
        }).then(data => {
            this.setState({ typeAgendaList: data });
        }).catch(err => {
            this.setState({ typeAgendaList: [] });
        });
    }

    validateControlAppointment = (appointmentData) => {
        return new Promise((resolve, reject) => {
            if (appointmentData.detalle_servicio.codigo.substr(0, 4) == "8903") {
                let services = [appointmentData.detalle_servicio]
                let dataSend = {
                    id_historia: this.props.id_historia,
                    servicios: services,
                    fecha_inicio: this.props.date,
                    id_agenda: appointmentData.id_agenda
                }
                fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/validar-cita-control', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(dataSend)
                }).then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error('Ha ocurrido un error con la Validación');
                    }
                }).then(data => {
                    resolve(data.excento);
                }).catch((error) => {
                    resolve(false);
                });
            }
            else {
                resolve(false);
            }
        });
    }

    render() {

        const ListAilable = () => {
            return (<MCADAailableTimesList
                reactTableData={this.state.availableTimes}
                ReactTableActions={MCADAailableTimesListActions}
                handlerConfirmedCitas={this.handlerConfirmedCitas}
                validateAgendaConfirmedSome={this.validateAgendaConfirmedSome}
                updating={true}
            />);
        }

        return (
            <>
                <Modal
                    open={this.props.openModalChangingAppointment}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <h4 className="bold-text">Reagendar Cita</h4>
                        <label>Seleccione la Fecha y el Servicio para ir Filtrando la Disponibilidad</label>
                        <Row>
                            <Col md={4}>
                                <br />
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <DatePicker
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            variant="static"
                                            label="Fecha"
                                            autoOk={true}
                                            disableToolbar={true}
                                            value={this.props.date}
                                            onChange={(date) => {
                                                this.props.handlerDate(new Date(date));
                                                this.verifyAvailableTimes(new Date(date), this.props.serviceChangeDate);
                                            }}
                                            format="DD/MM/yyyy"
                                            animateYearScrolling
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>

                                <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true,
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    <InputLabel shrink={true} id="select-type-agenda-label">Tipo de Agenda</InputLabel>
                                    <Select
                                        labelId="select-type-agenda-label"
                                        id="select-type-agenda"
                                        value={this.state.typeAgenda}
                                        onChange={(event) => {
                                            this.setState({ typeAgenda: event.target.value }, () => {
                                                this.verifyAvailableTimes(this.props.date, this.props.serviceChangeDate);
                                            })
                                        }}
                                    >
                                        {this.state.typeAgendaList.map((typeA, index) => {
                                            return <MenuItem key={typeA.id_atencion} value={typeA.id_atencion}>{typeA.atencion}</MenuItem>
                                        })}
                                    </Select>
                                    <FormHelperText>{this.state.errors.type_agenda}</FormHelperText>
                                </FormControl>

                                <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true,
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    <InputLabel shrink={true} id="services-reassign-label">Servicios</InputLabel>
                                    <Select
                                        labelId="services-reassign-label"
                                        id="services-reassign"
                                        disabled={this.state.typeAgenda == null}
                                        value={this.props.serviceChangeDate}
                                        onChange={(event) => {
                                            this.props.handlerServiceChangeDate(event.target.value);
                                            this.verifyAvailableTimes(this.props.date, event.target.value);
                                        }}
                                    >
                                        {this.props.activitiesAppointment.map((activity, index) => {
                                            return <MenuItem key={activity.id_servicio} value={activity.id_servicio}>{`${activity.codigo} - ${activity.servicios}`}</MenuItem>
                                        })}
                                    </Select>
                                    <FormHelperText>{this.state.errors.professional}</FormHelperText>
                                </FormControl>
                                <br />
                                <div style={{ fontSize: 12, maxHeight: 100, width: '95%', overflowY: 'scroll' }}>
                                    <b>Información de Cambios:</b>
                                    <br />
                                    <ul>
                                        {this.props.activitiesAppointment.map((activity) => {
                                            return (
                                                <li>
                                                    {this.validateCalendarConfirmedSome(activity.id_servicio) ? <>
                                                        <FontAwesomeIcon style={{ color: '#fd7e14' }} icon={faClock} />
                                                        <b style={{ color: '#fd7e14' }}>{this.validateCalendarConfirmed(activity.id_servicio)}</b></> : null}
                                                    {activity.codigo + "-" + activity.servicios}
                                                    <br />
                                                    {/* {this.validateExcentPayment(activity.id_servicio) ? <b className="text-danger">No genera cobro</b> : null} */}
                                                </li>);
                                        })}
                                    </ul>
                                </div>

                            </Col>
                            <Col md={8}>
                                {
                                    this.state.isLoading == false ? <>
                                        {this.state.availableTimes.length > 0 ? <ListAilable /> : <b>No hay disponibilidad con los Filtros seleccionados</b>}
                                    </>
                                        :
                                        <div className="text-center">
                                            <Spinner animation="border" variant="success" />
                                        </div>
                                }
                            </Col>
                        </Row>
                        <div style={{ marginTop: 10, display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>

                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                color='primary'
                                onClick={() => {
                                    this.setState({ openAlert: true, modalAlert: { color: 'warning', title: 'Reasignacion de Cita', message: 'Esta a Punto de Reagendar la Cita, desea continuar?' } });
                                }}
                            >
                                Confirmar Cambios
                            </Button>

                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                onClick={() => {
                                    this.cleanData();
                                }}
                            >
                                Cancelar
                            </Button>
                        </div>
                    </div>
                </Modal>

                {this.state.openAlert ?
                    <ModalMessage
                        color={this.state.modalAlert.color}
                        title={this.state.modalAlert.title}
                        message={this.state.modalAlert.message}
                        modal={this.state.openAlert}
                        toggle={() => {
                            this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } });
                        }}
                        onOk={() => {
                            if (this.state.modalAlert.color == "warning") {
                                this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } }, () => {
                                    this.confirmedNewCitas();
                                });
                            }
                            else if (this.state.modalAlert.color == "success") {
                                this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } }, () => {
                                    this.props.reloadAgenda();
                                });
                            }
                            else {
                                this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } });
                            }
                        }}
                    /> : null}
            </>);
    }
}

export default ModalChangeAppointmentDate;
